/* eslint import/no-extraneous-dependencies:0 */
import { createBrowserHistory } from 'history';

const history = createBrowserHistory();

export default history;
